import { render, staticRenderFns } from "./index.vue?vue&type=template&id=75c0f6f2&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/jenkins/workspace/model-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75c0f6f2')) {
      api.createRecord('75c0f6f2', component.options)
    } else {
      api.reload('75c0f6f2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=75c0f6f2&", function () {
      api.rerender('75c0f6f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CompClip/index.vue"
export default component.exports